var get, getRecommendationConclusionsSectionId, hasConclusionSection;

get = require('lodash').get;

hasConclusionSection = function(recommendation, sectionId) {
  return _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === sectionId;
  });
};

getRecommendationConclusionsSectionId = function(recommendation, isGps) {
  if (isGps == null) {
    isGps = false;
  }
  if (isGps || hasConclusionSection(recommendation, 'goodPracticeStatement')) {
    return 'goodPracticeStatement';
  } else if (hasConclusionSection(recommendation, 'decision')) {
    return 'decision';
  } else {
    return 'recommendation';
  }
};

module.exports = {
  getRecommendationConclusionsSectionId: getRecommendationConclusionsSectionId,
  hasConclusionSection: hasConclusionSection
};
